// Constants
export const info_egresos = () => {
  return {
    info_egresos: {
      id: {
        namepath: ['informes_egresos','afiliado_incapacidades'],        
        type: "number",
        label: "id",
        placeholder: "",
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: true,
          predeterminate: null,
        }
      },
      id_datos_razon: {
        type: "text",
        label: "razon",
        placeholder: "",
        namepath: ['informes_egresos','afiliado_incapacidades'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: 2,
          list: "datos_razon",
          label: 'name'
        }
      },
      id_info_incapacidades: {
        type: "number",
        label: "razon",
        placeholder: "",
        namepath: ['informes_egresos','afiliado_incapacidades'],
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: null,
        }
      },
      name: {
        type: "text",
        label: "Nombre",
        placeholder: "",
        namepath: ['informes_egresos','afiliado_incapacidades'],
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: null,
        }
      },
      id_list_documento: {
        type: "text",
        label: "razon",
        placeholder: "",
        namepath: ['informes_egresos','afiliado_incapacidades'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: 1,
          list: "list_documento",
          label: 'name'
        }
      },
      consecutivo: {
        type: "number",
        label: "Consecutivo",
        placeholder: "",
        namepath: ['informes_egresos','afiliado_incapacidades'],
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: 0,
        }
      },  
      documento: {
        namepath: ['informes_egresos','afiliado_incapacidades'],
        type: 'number',
        label: 'Documento',
        placeholder: '',
        description: 'documento',
        validate: '',
        datatype: {
          type: 'price', 
          disabled: false,
          predeterminate: null,
          prepend: '',
          append: '',
        }
      },
      telefonos: {
        namepath: ['informes_egresos','afiliado_incapacidades'],
        type: 'text',
        label: 'Teléfonos',
        placeholder: '',
        description: 'Telefonos',
        validate: '',
        datatype: {
          type: 'input', 
          disabled: false,
          predeterminate: null,
        }
      },
      direccion: {
        namepath: ['informes_egresos','afiliado_incapacidades'],
        type: 'text',
        label: 'Dirección',
        placeholder: '',
        description: 'direccion',
        validate: '',
        datatype: {
          type: 'input', 
          disabled: false,
          predeterminate: null,
        }
      },
      descripcion: {
        type: "text",
        label: "Descripción",
        placeholder: "",
        namepath: ['informes_egresos','afiliado_incapacidades'],
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: null,
        }
      },
      valor: {
        namepath: ['informes_egresos','afiliado_incapacidades'],
        type: 'number',
        label: 'Valor',
        placeholder: '',
        description: 'Valor',
        validate: '',
        datatype: {
          type: 'price', 
          disabled: false,
          predeterminate: 0,
          prepend: '$',
          append: '',
        }
      },
      fecha: {
        type: "number",
        label: "fecha",
        placeholder: "",
        namepath: ['informes_egresos','afiliado_incapacidades'],
        description: "",
        validate: "",
        datatype: {
          type: "date",
          disabled: false,
          predeterminate: null,
        }
      },
      id_list_users: {
        type: "text",
        label: "Radicador",
        placeholder: "",
        namepath: ['informes_egresos','afiliado_incapacidades'],
        description: "",
        validate: "required",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: null,
          list: "list_users",
          label: 'name',
        }
      },
      gastos_menores: {
        type: "boolean",
        label: "gastos menores",
        placeholder: "",
        namepath: ['informes_egresos','afiliado_incapacidades'],
        description: "",
        validate: "",
        datatype: {
          type: "check",
          disabled: false,
          predeterminate: 0,
        }
      },
      descontar_cuadre: {
        type: "boolean",
        label: "descontar cuadre",
        placeholder: "",
        namepath: ['informes_egresos','afiliado_incapacidades'],
        description: "",
        validate: "",
        datatype: {
          type: "check",
          disabled: false,
          predeterminate: 1,
        }
      },  
      caja: {
        type: "boolean",
        label: "descontar cuadre",
        placeholder: "",
        namepath: ['informes_egresos','afiliado_incapacidades'],
        description: "",
        validate: "",
        datatype: {
          type: "radio",
          disabled: false,
          predeterminate: 0,
        }
      }, 
      nota_delete: {
        type: "text",
        label: "Nota",
        placeholder: "",
        namepath: ['informes_egresos','afiliado_incapacidades'],
        description: "",
        validate: "required",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: null
        }
      }, 
    }
  }
}

